/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignUserDataSchema = z.object({
	id: z.string(),
	email: z.string(),
	firstname: z.string().nullable(),
	lastname: z.string().nullable(),
	role: z.string().nullable(),
})

export type CampaignUserDataSchema = z.infer<typeof campaignUserDataSchema>
